<!--  -->
<template>
  <div>
    <div id="cont">
      <div class="cont">
        <div class="cont_l">
          <div class="cont_l_01">
            <div class="cont_l_02">
              <img :src="images.sb_03">
            </div>
            <div class="cont_l_03">
              <ul class="lit01">
                <li class="lit01_c">
                  <p class="littitle">{{text.device01}}</p>
                  <ul class="lit02">
                    <li class="lit02_a">
                      <router-link to="/deviceew/lglzew">{{text.device02}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/deviceew/ggscew">{{text.device03}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/deviceew/gjscew">{{text.device04}}</router-link>
                    </li>
                  </ul>

                  <p class="littitle">{{text.device05}}</p>

                  <ul class="lit02">
                    <li class="lit02_a">
                      <router-link to="/deviceew/gsplew">{{text.device06}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/deviceew/spfrew">{{text.device07}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/deviceew/xxzjew">{{text.device08}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/deviceew/dkzjew">{{text.device09}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/deviceew/lhlbew">{{text.device10}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/deviceew/jyjjew">{{text.device11}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/deviceew/zsthew">{{text.device12}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/deviceew/lxthew">{{text.device13}}</router-link>
                    </li>
                  </ul>

                  <p class="littitle">{{text.device14}}</p>

                  <ul class="lit02">
                    <li class="lit02_a">
                      <router-link to="/deviceew/jcjew">{{text.device15}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/deviceew/jcmjew">{{text.device16}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/deviceew/zsmjew">{{text.device17}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/deviceew/jtlgew">{{text.device18}}</router-link>
                    </li>
                  </ul>

                  <p class="littitle">{{text.device19}}</p>
                  <ul class="lit02">
                    <li class="lit02_a">
                      <router-link to="/deviceew/dkzgew">{{text.device20}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/deviceew/lxgpew">{{text.device21}}</router-link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <div class="cont_l_04"></div>
          </div>
        </div>
        <div class="cont_r">
          <div class="cont_r_t">
            <div class="cont_r_t01">
              <span>{{text.profile3}}</span>
              <span>：</span>
              <span>{{text.profile4}}</span>
              <span>-</span>
              <span>{{text.device22}}</span>
            </div>
          </div>
          <div class="cont_r_b">
            <div id="rightdiv">
              <router-view></router-view>
            </div>
            <div class="cont_r_b10">
              <router-link to="/bbsew" target="_blank">
                <img :src="images.scy_03">
              </router-link>
            </div>
            <div class="clear"></div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        scy_03: require("../../../assets/img/ew/scy_03.jpg"),
        sb_03: require("../../../assets/img/ew/sb_03.jpg")
      },
      text: {
        profile3: "",
        profile4: "Главная страница",
        device01: "Комплект оборудования",
        device02: "Линия непрерывной разливки и прокатки алюминиевых",
        device03: "Линия непрерывной разливки и прокатки медных труб",
        device04: "Линия производства арматуры",
        device05: "Оборудование для обработки",
        device06: "Барабан кассетного волочения",
        device07: "Машина послойной бухтосвертки",
        device08: "Планетарный прокатный стан",
        device09: "Многороликовый прокатный стан",
        device10: "Комбинированная волочильная линия",
        device11: "Экструдер в сборе",
        device12: "Колпаковая печь для отжиг",
        device13: "Печь для непрерывных отжиг",
        device14: "Оборудование для экструзии и",
        device15: "Экструдер для пластмассы",
        device16: "Экструзионная форма",
        device17: "Форма для литья под давлением",
        device18: "Шнек и цилиндр",
        device19: "",
        device20: "",
        device21: "",
        device22: "Оборудование и решения"
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/ew/device/device.vue